import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/NavList/NavList.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/nav-list/react/latest'} mdxType="DeprecationBanner" />
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {NavList} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Simple`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<NavList>
  <NavList.Item href="/" aria-current="page">
    Home
  </NavList.Item>
  <NavList.Item href="/about">About</NavList.Item>
  <NavList.Item href="/contact">Contact</NavList.Item>
</NavList>
`}</code></pre>
    <h3>{`With leading icons`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<NavList>
  <NavList.Item href="/" aria-current="page">
    <NavList.LeadingVisual>
      <HomeIcon />
    </NavList.LeadingVisual>
    Dashboard
  </NavList.Item>
  <NavList.Item href="/pulls">
    <NavList.LeadingVisual>
      <GitPullRequestIcon />
    </NavList.LeadingVisual>
    Pull requests
  </NavList.Item>
  <NavList.Item href="/issues">
    <NavList.LeadingVisual>
      <IssueOpenedIcon />
    </NavList.LeadingVisual>
    Issues
  </NavList.Item>
</NavList>
`}</code></pre>
    <h3>{`With other leading visuals`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<NavList>
  <NavList.Item href="/general" aria-current="page">
    <NavList.LeadingVisual>
      <span aria-hidden>#️⃣</span>
    </NavList.LeadingVisual>
    General
  </NavList.Item>
  <NavList.Item href="/q-a">
    <NavList.LeadingVisual>
      <span aria-hidden>🙏</span>
    </NavList.LeadingVisual>
    Q&A
  </NavList.Item>
  <NavList.Item href="/show-and-tell">
    <NavList.LeadingVisual>
      <span aria-hidden>🙌</span>
    </NavList.LeadingVisual>
    Show and tell
  </NavList.Item>
</NavList>
`}</code></pre>
    <h3>{`With trailing visuals`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<NavList>
  <NavList.Item href="/inbox" aria-current="page">
    Inbox
    <NavList.TrailingVisual>1,234</NavList.TrailingVisual>
  </NavList.Item>
  <NavList.Item href="/saved">Saved</NavList.Item>
  <NavList.Item href="/done">Done</NavList.Item>
</NavList>
`}</code></pre>
    <h3>{`With a heading`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<>
  <Heading as="h3" id="workflows-heading" sx={{fontSize: 2, ml: 3}}>
    Workflows
  </Heading>
  <NavList aria-labelledby="workflows-heading">
    <NavList.Item href="/" aria-current="page">
      All workflows
    </NavList.Item>
    <NavList.Item href="/ci">CI</NavList.Item>
    <NavList.Item href="/deploy">Deploy</NavList.Item>
    <NavList.Item href="/release">Release</NavList.Item>
  </NavList>
</>
`}</code></pre>
    <h3>{`With aria-label`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<NavList aria-label="Security">
  <NavList.Item href="/" aria-current="page">
    Overview
  </NavList.Item>
  <NavList.Item href="/policy">Security policy</NavList.Item>
  <NavList.Item href="/advisories">Security advisories</NavList.Item>
</NavList>
`}</code></pre>
    <h3>{`With groups`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<NavList>
  <NavList.Group title="Overview">
    <NavList.Item href="/getting-started" aria-current="page">
      Getting started
    </NavList.Item>
  </NavList.Group>
  <NavList.Group title="Components">
    <NavList.Item href="/Avatar">Avatar</NavList.Item>
    <NavList.Item href="/Button">Button</NavList.Item>
    <NavList.Item href="/Label">Label</NavList.Item>
  </NavList.Group>
</NavList>
`}</code></pre>
    <h3>{`With sub-items`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<NavList>
  <NavList.Item href="/branches">Branches</NavList.Item>
  <NavList.Item href="/tags">Tags</NavList.Item>
  <NavList.Item>
    Actions
    <NavList.SubNav>
      <NavList.Item href="/actions" aria-current="page">
        General
      </NavList.Item>
      <NavList.Item href="/actions/runners">Runners</NavList.Item>
    </NavList.SubNav>
  </NavList.Item>
</NavList>
`}</code></pre>
    <Note variant="warning" mdxType="Note">
      <p>{`If a `}<inlineCode parentName="p">{`NavList.Item`}</inlineCode>{` contains a `}<inlineCode parentName="p">{`NavList.SubNav`}</inlineCode>{`, the `}<inlineCode parentName="p">{`NavList.Item`}</inlineCode>{` will render as a `}<inlineCode parentName="p">{`<button>`}</inlineCode>{` and the `}<inlineCode parentName="p">{`as`}</inlineCode>{` prop and `}<inlineCode parentName="p">{`href`}</inlineCode>{` prop will be ignored.`}</p>
    </Note>
    <h3>{`With nested sub-items`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<NavList>
  <NavList.Item href="/branches">Branches</NavList.Item>
  <NavList.Item href="/tags">Tags</NavList.Item>
  <NavList.Item>
    Actions
    <NavList.SubNav>
      <NavList.Item href="/actions" aria-current="page">
        General
      </NavList.Item>
      <NavList.Item href="/actions/runners">
        Runners
        <NavList.SubNav>
          <NavList.Item href="/actions/runners/runner-1">Runner 1</NavList.Item>
          <NavList.Item href="/actions/runners/runner-2">Runner 2</NavList.Item>
        </NavList.SubNav>
      </NavList.Item>
    </NavList.SubNav>
  </NavList.Item>
</NavList>
`}</code></pre>
    <Note variant="warning" mdxType="Note">
      <p>{`We only allow for up to 4 levels of nested subnavs. If more than 4 levels is required, it's a good sign that the navigation design needs to be rethought.`}</p>
    </Note>
    <h3>{`With a divider`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live drafts",
        "live": true,
        "drafts": true
      }}>{`<NavList>
  <NavList.Item href="/" aria-current="page">
    Dashboard
  </NavList.Item>
  <NavList.Item href="/pulls">Pull requests</NavList.Item>
  <NavList.Item href="/issues">Issues</NavList.Item>
  <NavList.Divider />
  <NavList.Item href="/marketplace">Marketplace</NavList.Item>
  <NavList.Item href="/explore">Explore</NavList.Item>
</NavList>
`}</code></pre>
    <h3>{`With React Router`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {Link, useMatch, useResolvedPath} from 'react-router-dom'
import {NavList} from '@primer/react'

function NavItem({to, children}) {
  const resolved = useResolvedPath(to)
  const isCurrent = useMatch({path: resolved.pathname, end: true})
  return (
    <NavList.Item as={Link} to={to} aria-current={isCurrent ? 'page' : undefined}>
      {children}
    </NavList.Item>
  )
}

function App() {
  return (
    <NavList>
      <NavItem to="/">Dashboard</NavItem>
      <NavItem to="/pulls">Pull requests</NavItem>
      <NavItem to="/issues">Issues</NavItem>
    </NavList>
  )
}
`}</code></pre>
    <h3>{`With Next.js`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {useRouter} from 'next/router'
import Link from 'next/link'
import {NavList} from '@primer/react'

function NavItem({href, children}) {
  const router = useRouter()
  const isCurrent = typeof href === 'string' ? router.asPath === href : router.pathname === href.pathname
  return (
    <Link href={href} passHref>
      <NavList.Item aria-current={isCurrent ? 'page' : false}>{children}</NavList.Item>
    </Link>
  )
}

function App() {
  return (
    <NavList>
      <NavItem href="/">Dashboard</NavItem>
      <NavItem href="/pulls">Pull requests</NavItem>
      <NavItem href="/issues">Issues</NavItem>
      <NavItem
        href={{
          pathname: '/[owner]/[repo]',
          query: {owner, repo},
        }}
      >
        Summary
      </NavItem>
    </NavList>
  )
}
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      